/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReImportSpecification } from './ReImportSpecification';
import {
    ReImportSpecificationFromJSON,
    ReImportSpecificationFromJSONTyped,
    ReImportSpecificationToJSON,
    ReImportSpecificationToJSONTyped,
} from './ReImportSpecification';

/**
 * 
 * @export
 * @interface ReportRetryRequest
 */
export interface ReportRetryRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportRetryRequest
     */
    documentKey: string;
    /**
     * 
     * @type {Array<ReImportSpecification>}
     * @memberof ReportRetryRequest
     */
    reImportSpecifications?: Array<ReImportSpecification>;
}

/**
 * Check if a given object implements the ReportRetryRequest interface.
 */
export function instanceOfReportRetryRequest(value: object): value is ReportRetryRequest {
    if (!('documentKey' in value) || value['documentKey'] === undefined) return false;
    return true;
}

export function ReportRetryRequestFromJSON(json: any): ReportRetryRequest {
    return ReportRetryRequestFromJSONTyped(json, false);
}

export function ReportRetryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportRetryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'documentKey': json['documentKey'],
        'reImportSpecifications': json['reImportSpecifications'] == null ? undefined : ((json['reImportSpecifications'] as Array<any>).map(ReImportSpecificationFromJSON)),
    };
}

export function ReportRetryRequestToJSON(json: any): ReportRetryRequest {
    return ReportRetryRequestToJSONTyped(json, false);
}

export function ReportRetryRequestToJSONTyped(value?: ReportRetryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentKey': value['documentKey'],
        'reImportSpecifications': value['reImportSpecifications'] == null ? undefined : ((value['reImportSpecifications'] as Array<any>).map(ReImportSpecificationToJSON)),
    };
}

